/* eslint no-use-before-define: 0 */  // --> OFF
<template>
  <v-form>
    <v-layout style="margin-top: 12vh;" wrap justify-center>
      <v-flex xs12 sm12 md6>
        <v-card class="ma-4 elevation-12">
          <v-card-text>
            <v-img :src="require('./../../assets/logo_qclass_agenda.png')" align="center" justify="center" contain
              max-height="40px" />
            <v-toolbar-title class="ma-2 text-center">
              Acesso ao Sistema
            </v-toolbar-title>
            <v-form>
              <p v-if="errors.length">
                <b>Por favor, corrija o(s) seguinte(s) erro(s):</b>
              <ul>
                <li v-for="error in errors" :key="error" style="color:red">
                  {{ error }}
                </li>
              </ul>
              </p>
              <v-text-field v-model="cpf" v-mask="'###.###.###-##'" prepend-icon="mdi-account-lock" name="cpf"
                label="CPF" placeholder="Informe seu CPF:" required :append-icon="showCpf ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showCpf ? 'text' : 'password'" @click:append="showCpf = !showCpf" />
              <v-text-field v-model="renach" v-mask="'###.###.###'" prepend-icon="mdi-account-lock" name="renach"
                label="Renach" placeholder="Informe seu Renach:" required
                :append-icon="showRenach ? 'mdi-eye' : 'mdi-eye-off'" :type="showRenach ? 'text' : 'password'"
                @click:append="showRenach = !showRenach" />
              <v-text-field v-model="codeCfc" v-mask="'#########'" prepend-icon="mdi-home-city" name="Codigo CFC"
                label="Código CFC" placeholder="Informe o código do CFC:" required />
            </v-form>
          </v-card-text>
          <v-card-actions class="mx-9">
            <v-btn :disabled="disabledButtonLogin" color="red lighten-1" class="white--text text-capitalize pa-2 mb-2"
              block @click="Login">
              Entrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-form>
</template>
<script>
import { mask } from "vue-the-mask";
import Api from "../../service/Api";
import AlunoApi from "../../ws/aluno";
import CfcApi from "../../ws/cfc";

export default {
  directives: { mask },
  data: () => ({
    errors: [],
    cpf: null,
    renach: null,
    codeCfc: null,
    showCpf: false,
    showRenach: false,
    cfc: {},
    disabledButtonLogin: false,
  }),
  computed: {},
  mounted() { },
  methods: {
    async Login() {

      this.errors = [];
      if (!this.cpf) {
        this.errors.push('O CPF é obrigatório.');
      }

      if (!this.renach) {
        this.errors.push('O Renach é obrigatório.');
      }

      if (!this.codeCfc) {
        this.errors.push('O código do CFC é obrigatório.');
      }

      if (this.cpf == null && this.renach == null && this.codeCfc == null) {
        return true;
      } else {
        //Remove mask input
        const cpf = this.cpf.replace(/\D/g, "");
        const renach = this.renach.replace(/\D/g, "");

        //Set Parameter in Header
        Api.defaults.headers.codeCfc = this.codeCfc;
        Api.defaults.headers.cpfAluno = cpf;

        const { data } = await CfcApi.findCfc();
        if (!this.checkCodeCfc(data)) {
          this.disabledButtonLogin = false;
          this.errors.push(data.mensagem);
          return;
        }

        try {
          const response = await AlunoApi.login(cpf, renach);
          if (response.data.status === 200) {
            const { token } = response.data.token;
            const responseValidaToken = await AlunoApi.validaToken(token)
            const aluno = responseValidaToken.data;
            this.$store.commit('updateCfc', this.cfc);
            this.$store.commit('updateAluno', aluno);
            localStorage.token = token;
            localStorage.cpf = cpf;
            localStorage.codeCfc = this.codeCfc;
            this.$router.push('/aluno/profile');
          } else {
            this.errors.push(response.data.message);
            this.disabledButtonLogin = false;
          }
        } catch (erro) {
          this.disabledButtonLogin = false;
          if (erro.response.status == 404) {
            this.disabledButtonLogin = false;
            alert(`${erro.response.status} - Dados de Login Invalido`)
          }
        }
      }
    },
    checkCodeCfc(item) {
      try {
        if (item.status === 200) {
          this.cfc = {
            id: item.cfc.id,
            nome: item.cfc.nome_fantasia,
            cnpj: item.cfc.cnpj,
            codigo: item.cfc.codigo,
            codeCfc: this.codeCfc,
            uf: item.cfc.uf
          };
          return true
        } else {
          return false;
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
